var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrolley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 16,
    fill: "#FFF3ED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_143_407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1906 11.5232C28.778 11.5587 28.4724 11.9221 28.5079 12.3347C28.5435 12.7473 28.9069 13.0529 29.3195 13.0173L32.8044 12.414C33.217 12.3784 33.5226 12.015 33.487 11.6024C33.4514 11.1898 33.0881 10.8842 32.6755 10.9198L29.1906 11.5232Z",
    fill: "#C78477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5625 34.289H28.3916C28.9019 34.289 29.3156 33.9532 29.3156 33.539C29.3156 33.1248 28.9019 32.7889 28.3916 32.7889H9.5625V34.289Z",
    fill: "#C78477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5166 13.7249H29.4912V17.387H30.5166V13.7249Z",
    fill: "#C78477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5166 26.147H29.4912V29.8091H30.5166V26.147Z",
    fill: "#C78477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.706 37.0161L19.706 38.0415L16.0439 38.0415L16.0439 37.0161L19.706 37.0161Z",
    fill: "#C78477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1438 38.4361C11.8202 38.6934 11.3493 38.6396 11.092 38.316C10.8348 37.9924 10.8885 37.5215 11.2122 37.2642L13.0922 35.7649L13.0913 35.7638C13.2295 35.6535 13.3948 35.6001 13.5589 35.6002V35.6001H26.2958C26.71 35.6001 27.0458 35.9359 27.0458 36.3501C27.0458 36.7644 26.71 37.1002 26.2958 37.1002H13.819L12.1438 38.4361H12.1438ZM29.678 33.5188C29.678 33.933 29.3422 34.2688 28.928 34.2688C28.5138 34.2688 28.178 33.933 28.178 33.5188V11.6001C28.178 9.04705 28.8258 7.72827 30.2055 7.01652C31.4692 6.36457 33.2343 6.3501 35.678 6.3501C36.0922 6.3501 36.428 6.68591 36.428 7.10012C36.428 7.51432 36.0922 7.85013 35.678 7.85013C33.4425 7.85013 31.8325 7.86093 30.8911 8.34659C30.0656 8.77242 29.678 9.70373 29.678 11.6001V33.5188L29.678 33.5188Z",
    fill: "#C78477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0717 6.28235H32.1587V8.14478H37.0717V6.28235Z",
    fill: "#C31918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.343 6.03689C32.343 5.85552 32.196 5.7085 32.0146 5.7085C31.8333 5.7085 31.6862 5.85552 31.6862 6.03689V8.3903C31.6862 8.57167 31.8333 8.71869 32.0146 8.71869C32.196 8.71869 32.343 8.57167 32.343 8.3903V6.03689Z",
    fill: "#C31918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2807 32.5413C28.9347 32.5413 27.7159 33.087 26.8337 33.9692C25.9514 34.8514 25.4057 36.0702 25.4057 37.4163C25.4057 38.7624 25.9514 39.9811 26.8337 40.8634C27.7159 41.7456 28.9346 42.2913 30.2807 42.2913C31.6268 42.2913 32.8456 41.7456 33.7278 40.8634C34.6101 39.9811 35.1558 38.7624 35.1558 37.4163C35.1558 36.0702 34.6101 34.8514 33.7278 33.9692C32.8456 33.087 31.6269 32.5413 30.2807 32.5413Z",
    fill: "#C31918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2808 34.417C29.4527 34.417 28.7029 34.7527 28.1601 35.2956C27.6172 35.8384 27.2815 36.5882 27.2815 37.4163C27.2815 38.2443 27.6172 38.9942 28.1601 39.537C28.7029 40.0798 29.4527 40.4156 30.2808 40.4156C31.1088 40.4156 31.8587 40.0798 32.4015 39.537C32.9443 38.9942 33.2801 38.2443 33.2801 37.4163C33.2801 36.5882 32.9443 35.8384 32.4015 35.2956C31.8587 34.7527 31.1088 34.417 30.2808 34.417Z",
    fill: "#C78477"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2805 35.0824C29.6362 35.0824 29.0526 35.3437 28.6302 35.7661C28.2078 36.1885 27.9465 36.7721 27.9465 37.4164C27.9465 38.0608 28.2078 38.6444 28.6302 39.0668C29.0526 39.4892 29.6362 39.7505 30.2805 39.7505C30.9249 39.7505 31.5085 39.4892 31.9309 39.0668C32.3533 38.6444 32.6146 38.0608 32.6146 37.4164C32.6146 36.7721 32.3533 36.1885 31.9309 35.7661C31.5085 35.3437 30.9249 35.0824 30.2805 35.0824Z",
    fill: "#FFE5DA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5777 36.7136C29.7573 36.534 30.0059 36.4227 30.2805 36.4227C30.5552 36.4227 30.8038 36.534 30.9834 36.7136C31.163 36.8932 31.2742 37.1418 31.2742 37.4164C31.2742 37.6911 31.163 37.9397 30.9834 38.1193C30.8038 38.2989 30.5552 38.4101 30.2805 38.4101C30.0059 38.4101 29.7573 38.2989 29.5777 38.1193C29.3981 37.9397 29.2868 37.6911 29.2868 37.4164C29.2868 37.1418 29.3981 36.8932 29.5777 36.7136Z",
    fill: "#C31918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8458 11.147C18.4527 11.147 18.6123 11.147 11.2208 11.147C10.8066 11.147 10.4708 11.4828 10.4708 11.897V31.397C10.4708 31.8112 10.8066 32.147 11.2208 32.147H25.8458C26.26 32.147 26.5958 31.8112 26.5958 31.397V11.897C26.5958 11.4828 26.26 11.147 25.8458 11.147Z",
    fill: "#FFE5DA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1357 28.5457H18.7149V29.1072H25.1357V28.5457Z",
    fill: "#C31918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4268 29.7014V28.3596H11.9443L12.9092 27.0178L13.874 28.3596H13.3916V29.7014H12.4268Z",
    fill: "#C31918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7142 29.7014V28.3596H14.2318L15.1966 27.0178L16.1614 28.3596H15.679V29.7014H14.7142Z",
    fill: "#C31918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1682 30.1593H11.9312V30.5964H16.1682V30.1593Z",
    fill: "#C31918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1357 30.0349H18.7149V30.5965H25.1357V30.0349Z",
    fill: "#C31918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5645 11.147H20.502V15.4343V15.4639L20.175 15.9545L19.8466 15.4619L19.5183 15.9545L19.19 15.4619L18.8617 15.9545L18.5333 15.4619L18.205 15.9545L17.8766 15.4619L17.5483 15.9545L17.2199 15.4619L16.8916 15.9545L16.5645 15.4639V15.4619V11.147Z",
    fill: "#C31918"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_143_407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrolley);
export default __webpack_public_path__ + "static/media/trolley.2b0e81717ce37a70b7d49e466164e53c.svg";
export { ForwardRef as ReactComponent };